import { render, staticRenderFns } from "./FeaturedGuilds.vue?vue&type=template&id=5eb88455&scoped=true"
import script from "./FeaturedGuilds.vue?vue&type=script&lang=js"
export * from "./FeaturedGuilds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb88455",
  null
  
)

export default component.exports